import {useCallback, useState} from 'react';
// import {session} from '@netx/core-auth/collections/singleton/session';
import {useSession} from './useSession';
import {useReactQueryAuthenticate} from '../api';

export const useAuthenticate = () => {
	const session = useSession();
	// TODO: proper way to check authenticated here
	const [authenticated, setAuthenticated] = useState(false);
	const [loginMessage, setLoginMessage] = useState(session.data.loginMsg);
	const [sessionExpired, setSessionExpired] = useState(
		session.sessionExpired(),
	);
	const [samlServices] = useState(() => {
		const samlService = session.samlServices.find(
			(service) => service.type === 'saml',
		);
		if (!samlService) return undefined;
		return {
			...samlService,
		};
	});

	const authenticateMutation = useReactQueryAuthenticate({
		onError() {
			// dispatcher.trigger('auth:user:login:invalid');
		},
		onSuccess(sessionKey) {
			setAuthenticated(true);
			session.setCookie('sessionKey', sessionKey, 1);
			session.setKey(sessionKey);
			// dispatcher.trigger('auth:user:login:success');
			window.location.reload();
		},
	});

	const authenticateUser = useCallback(
		async (params: Parameters<typeof authenticateMutation.mutateAsync>[0]) => {
			setSessionExpired(false);
			setLoginMessage(undefined);
			return authenticateMutation.mutateAsync(params);
		},
		[],
	);

	return {
		authenticated,
		authenticating: authenticateMutation.isLoading,
		error: authenticateMutation.error,
		loginMessage,
		samlServices,
		sessionExpired,
		authenticatedAsOtherUser: session.data.loggedInAsOtherUser as boolean,

		authenticateUser,
	};
};

export default useAuthenticate;
